import { useCallback, useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import {
  AdminRoute,
  NotificationProvider,
  NotificationModal,
} from "imagine-ui";
import "./i18n";
import {
  AddressInfoContainer,
  DefectEditorContainer,
  DefectInfoContainer,
  HomeContainer,
} from "./containers";
import { ResidentLayout } from "./components";

function App() {
  return (
    <BrowserRouter basename={"/"}>
      <Routes>
        <Route element={<ResidentLayout />}>
          <Route
            path="/:addressCode"
            element={<AddressInfoContainer />}
          ></Route>
          <Route
            path="/:addressCode/create"
            element={<DefectEditorContainer mode="create" />}
          ></Route>
          <Route
            path="/:addressCode/:defectId/edit"
            element={<DefectEditorContainer mode="edit" />}
          ></Route>
          <Route
            path="/:addressCode/:defectId"
            element={<DefectInfoContainer />}
          ></Route>
        </Route>

        <Route path="*" element={<HomeContainer />}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
